import { Form, Select } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { getTranslatedFrequencyPresets } from "../../../constants/frequencyPresets";

const FrequencySelect = ({
  label,
  name,
  initialValue,
  disabledOption,
  readOnly,
  required,
  validationMessage,
  size,
  onChange = null,
}) => {
  const { t } = useTranslation();
  const frequencies = getTranslatedFrequencyPresets(t);

  const handleClear = () => {
    onChange && onChange(null);
  };

  const handlePartnerChange = (frequency) => {
    const selectedFrequency = frequencies.find((freq) => freq.id === frequency);
    onChange && onChange(selectedFrequency);
  };

  return (
    <Form.Item
      hasFeedback
      name={name}
      label={label}
      initialValue={initialValue}
      valuePropName={"value"}
      rules={[
        {
          required: required,
          message: validationMessage,
        },
      ]}
    >
      <Select
        size={size}
        allowClear
        disabled={readOnly}
        bordered={!readOnly}
        loading={false}
        showSearch={true}
        placeholder={t("schedules.frequancy")}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={handlePartnerChange}
        onClear={handleClear}
      >
        {frequencies.map((frequency) => {
          return (
            <Select.Option
              key={frequency.id}
              value={frequency.id}
              disabled={disabledOption && frequency.id === disabledOption}
            >
              {`${frequency.name}`}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default FrequencySelect;
